// generated from 14 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const ecommerceSourceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("ecommerce_source_filter"),
  comparison_key: z.enum([
    "1", // 13 (92.86%)
    "11", // 1 (7.14%)
  ]),
  display_name: z.string(),
  raw_value: z.string(),
  value: z.string(),
  varies_by_app_group: z.literal(false),
});
